var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",staticStyle:{"display":"block","width":"100%","height":"auto"},on:{"mouseover":_vm.onMouseOver,"mouseout":_vm.onMouseOut}})])
}
var staticRenderFns = []

export { render, staticRenderFns }